import { configureStore } from "@reduxjs/toolkit";

import userReducer from "./slices/userSlice";
import userProfileReducer from "./slices/userProfileSlice";
import gamesReducer from "./slices/gamesSlice";
import sessionsReducer from "./slices/sessionsSlice";
import messagesReducer from "./slices/messagesSlice";
import hostReducer from "./slices/hostSlice";
import requestsReducer from "./slices/requestsSlice";
import locationReducer from "./slices/locationSlice";

const store = configureStore({
  reducer: {
    user: userReducer,
    userProfile: userProfileReducer,
    games: gamesReducer,
    sessions: sessionsReducer,
    messages: messagesReducer,
    host: hostReducer,
    requests: requestsReducer,
    location: locationReducer,
  },
  middleware: (getDefaultMiddleware) => {
    const middleware = getDefaultMiddleware({
      serializableCheck: {
        // Ignore these action types for Firebase serialization
        ignoredActions: [
          "persist/PERSIST",
          "persist/REHYDRATE",
          "user/setUser",
          "user/setUserToken",
        ],
        // Ignore these field paths in all actions
        ignoredActionsPaths: ["meta.arg", "payload.timestamp", "payload"],
        // Ignore these paths in the state - Firebase user objects are not serializable
        ignoredPaths: [
          "items.dates",
          "user.user", // Firebase Auth user object
          "user.token", // Firebase token object
        ],
      },
    });

    return middleware;
  },
  devTools: process.env.NODE_ENV !== "production",
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
